import { IntelligencePersona } from '@@types/api.types';
import type { BadgeProps } from '@components/ui/badge';

/** AZ-451: display labels for the Intelligence Persona axis (org membership). Single-sourced for web. */
export const INTELLIGENCE_PERSONA_LABELS: Record<IntelligencePersona, string> = {
  [IntelligencePersona.PROGRAM_ADMIN]: 'Program Admin',
  [IntelligencePersona.MISSION_ENGINEER]: 'Mission Engineer',
  [IntelligencePersona.DECISION_MAKER]: 'Decision Maker',
  [IntelligencePersona.LIBRARIAN]: 'Librarian',
};

export const getIntelligencePersonaLabel = (persona?: IntelligencePersona | null): string =>
  persona ? INTELLIGENCE_PERSONA_LABELS[persona] : '—';

const INTELLIGENCE_PERSONA_BADGE_VARIANTS: Record<IntelligencePersona, BadgeProps['variant']> = {
  [IntelligencePersona.PROGRAM_ADMIN]: 'persona-program-admin',
  [IntelligencePersona.MISSION_ENGINEER]: 'persona-mission-engineer',
  [IntelligencePersona.DECISION_MAKER]: 'persona-decision-maker',
  [IntelligencePersona.LIBRARIAN]: 'persona-librarian',
};

export const getIntelligencePersonaBadgeVariant = (persona?: IntelligencePersona | null): BadgeProps['variant'] =>
  persona ? INTELLIGENCE_PERSONA_BADGE_VARIANTS[persona] : 'default';

/** AZ-451: short permission summaries so admins understand what each persona grants. */
export const INTELLIGENCE_PERSONA_DESCRIPTIONS: Record<IntelligencePersona, string> = {
  [IntelligencePersona.PROGRAM_ADMIN]: "Manages the organization's members and personas; can create and own studies.",
  [IntelligencePersona.MISSION_ENGINEER]: 'Creates and owns studies — builds missions, threads, tasks, and scoring.',
  [IntelligencePersona.DECISION_MAKER]:
    'Reviews briefs and signs off when assigned as Decision Maker of Record on a study.',
  [IntelligencePersona.LIBRARIAN]: 'Reference-library governance role; no study permissions yet.',
};

/** Persona options for selects, in the canonical ordering (governance first). */
export const INTELLIGENCE_PERSONA_OPTIONS: Array<{ description: string; label: string; value: IntelligencePersona }> = [
  IntelligencePersona.PROGRAM_ADMIN,
  IntelligencePersona.MISSION_ENGINEER,
  IntelligencePersona.DECISION_MAKER,
  IntelligencePersona.LIBRARIAN,
].map((value) => ({
  description: INTELLIGENCE_PERSONA_DESCRIPTIONS[value],
  label: INTELLIGENCE_PERSONA_LABELS[value],
  value,
}));
